/* eslint-disable @typescript-eslint/naming-convention */
import { get } from '@core/api/baseApi';
import { GetOrganizationTemplatesResponse } from '@core/types/ApiResponses';

const getOrganizationTemplates = (): Promise<GetOrganizationTemplatesResponse> =>
  get('/organizations/templates');

export { getOrganizationTemplates };
